import React from 'react'

import {
  HomeTabPageLinesContainer,
  ContentWrapper,
  HomeTabPageLinesContainerBg,
} from '../styles'

type Props = {
  children: React.ReactNode
  isHidden: boolean
  isVisible: boolean
  onFocused?: () => void
}

export const HomeTabPageLines = ({
  children,
  isHidden,
  isVisible,
  onFocused,
}: Props) => {
  return (
    <HomeTabPageLinesContainer
      $isHidden={isHidden}
      $isVisible={isVisible}
      onFocused={onFocused}
    >
      <HomeTabPageLinesContainerBg />
      <ContentWrapper>{children}</ContentWrapper>
    </HomeTabPageLinesContainer>
  )
}
